<template>
  <div>
    <Loader :loader-primario="loader" />

    <Alerta
      v-on:fecharModal="fecharModal"
      :exibir="modal.exibir"
      :titulo="modal.titulo"
      :mensagem="modal.mensagem"
      v-on:exclusao="excluir"
    />

    <ModalCertificacoes
      v-model="modalCertificacoes"
      :certificacao="certificacaoEditar"
      @thisLoader="thisLoader"
      v-on:fecha-modal="
        modalCertificacoes = false;
        buscarCertificacoesColaborador();
      "
      @erro="mensagemErro"
      @sucesso="mensagemSucesso"
      @mensagem="mensagem"
      @buscarCertificacao="buscarCertificacoesColaborador"
    />

    <ModalCurso
      v-model="modalCurso"
      :curso="cursoEditar"
      v-on:fecha-modal="fechaModalCurso()"
      @salvar="criarCurso"
      @editar="atualizarCurso"
    />

    <ModalEscolaridade
      v-if="modalEscolaridade"
      :escolaridade="escolaridadeEditar"
      v-on:fecha-modal="fechaModalFormacao()"
      @salvar="criarEscolaridade"
      @editar="atualizarEscolaridade"
    />

    <ModalExperiencia
      v-model="modalExperiencia"
      :nivel="nivelExperiencia"
      v-on:fecha-modal="
        modalExperiencia = false;
        buscarExperienciaPessoa();
      "
      @erro="mensagemErro"
      @sucesso="mensagemSucesso"
      @mensagem="mensagem"
      @thisLoader="thisLoader"
      @buscarExperiencia="buscarExperienciaPessoa"
    />

    <v-container>
      <div class="card">
        <v-row>
          <v-col cols="6">
            <div class="inicio-titulo">
              <v-img
                class="icone-titulo"
                src="../../assets/images/icone/espaco-colaborador/icone_formacao.svg"
              ></v-img>
              <h1 class="titulo mb-3">Formação</h1>
            </div>
          </v-col>

          <!-- <v-col v-if="numeroPendentes > 0">
            <div class="aviso-titulo">
              <v-icon size="20" color="#278b97">fa-circle-info</v-icon>
              <span>
                Você possui {{ numeroPendentes }}
                {{ numeroPendentes > 1 ? 'treinamentos pendentes' : 'treinamento pendente' }}!
                Confira em
                <a
                  target="_blank"
                  href="https://sistemas.hepta.com.br/sgh/pages/treinamento/dash-treinamentos/dash_treinamentos.html"
                >
                  SGH - Treinamentos
                  <i class="fas fa-external-link-alt"></i>
                </a>
              </span>
            </div>
          </v-col> -->
        </v-row>
        <v-tabs v-model="tab" grow background-color="#FFF" class="my-2" hide-slider show-arrows v-abas-acessiveis="'Seções de formação'">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-0" :class="tab == 'tab-0' ? 'tab tab-active' : 'tab'"
            >Introdução / FAQ</v-tab
          >
          <v-tab href="#tab-1" :class="tab == 'tab-1' ? 'tab tab-active' : 'tab'"
            >Certificações e Exames</v-tab
          >
          <v-tab href="#tab-2" :class="tab == 'tab-2' ? 'tab tab-active' : 'tab'">Cursos</v-tab>
          <v-tab href="#tab-3" :class="tab == 'tab-3' ? 'tab tab-active' : 'tab'"
            >Escolaridade</v-tab
          >
          <v-tab href="#tab-4" :class="tab == 'tab-4' ? 'tab tab-active' : 'tab'"
            >Experiência Técnica</v-tab
          >
        </v-tabs>
        <!-- Conteúdo Tabs -->
        <v-tabs-items v-model="tab" touchless>
          <v-divider color="#5bb0ba" class="my-8"></v-divider>

          <!-- Introdução / FAQ -->
          <v-tab-item value="tab-0">
            <div class="text-center">
              <h2 class="destaque titulo-secao">Guia do Módulo de Formação</h2>
              <p>
                “O nosso #CapitalHumano é nosso maior patrimônio. É ele que nos destaca e<br />
                diferencia no mercado. São vocês que fazem a Hepta ser uma<br />
                empresa que entrega competência como serviço” <br />
                <b>Roberto Villares - Diretor Executivo</b>
              </p>
              <p class="py-5">
                <b>
                  Esse é um sistema dedicado a conhecer a formação e habilitações técnicas e
                  profissionais de todo o #TImeHepta.<br />
                  Contamos com sua participação para garantirmos a atualização dos dados e a
                  melhoria constante da ferramenta.
                </b>
              </p>
              <h2 class="titulo-secao">Como podemos te ajudar?</h2>
            </div>
            <v-text-field
              @input="filtrarFaq()"
              v-model="faq"
              outlined
              clearable
              dense
              class="input-field espaco-input"
            >
              <template slot="label">
                <span class="input-field-text">Digite aqui sua dúvida</span>
              </template>
              <template v-slot:append>
                <v-icon class="input-field-text">fa-solid fa-magnifying-glass</v-icon>
              </template>
            </v-text-field>
            <v-expansion-panels v-for="faq in conteudoFaqFiltrado" multiple class="faq">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ faq.titulo }}
                  <template v-slot:actions>
                    <v-icon></v-icon>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>{{ faq.conteudo }}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-tab-item>
          <!-- Certificações e Exames -->
          <v-tab-item value="tab-1">
            <v-row class="titulo-tab">
              <h2 class="titulo-secao">Certificacões e Exames</h2>
              <v-btn @click="modalCertificacoes = true" class="botao-principal">
                <v-icon small class="mr-2">fas fa-circle-plus</v-icon>Adicionar
              </v-btn>
            </v-row>
            <v-container>
              <v-card v-if="dados_pessoais.isPJ" class="textPJ">
                {{ textoResponsabilidadePJ }}
              </v-card>
              <v-data-table :headers="cabecalhoCertificacoes" :items="certificacoes">
                <template v-slot:item.dataEmissao="{ item }">{{
                  dataItem(item.dataEmissao)
                }}</template>
                <template v-slot:item.dataValidade="{ item }">{{
                  dataItem(item.dataValidade)
                }}</template>
                <template v-slot:item.indAuditado="{ item }">
                  <div
                    v-if="item.indAuditado == false"
                    :class="statusValidacao('Aguardando Validação')"
                  >
                    Em Análise
                  </div>
                  <div v-else :class="statusValidacao('Validado')">Aceito</div>
                </template>
                <template v-slot:item.indDocumentoValido="{ item }">
                  <div class="acoes-tabela">
                    <v-tooltip top v-if="item.possuiDocumento">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="btn-acao-tabela"
                          aria-label="Baixar"
                          @click="downloadCertificacao(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="icone-acao">fa fa-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Baixar</span>
                    </v-tooltip>

                    <v-tooltip top v-if="item.indDocumentoValido == false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="btn-acao-tabela"
                          aria-label="Editar"
                          @click="(certificacaoEditar = item), (modalCertificacoes = true)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="icone-acao">fas fa-pen editar</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>

                    <v-tooltip top v-if="item.indAuditado == false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="btn-acao-tabela"
                          aria-label="Excluir"
                          @click="modalExclusao(item.codPessoaCertificacao, 'certificacao')"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="icone-acao">fas fa-trash excluir</v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>

                    <span
                      v-if="!item.possuiDocumento && item.indDocumentoValido && item.indAuditado"
                      >Não disponível</span
                    >
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <!-- Cursos -->
          <v-tab-item value="tab-2">
            <v-row class="titulo-tab">
              <h2 class="titulo-secao">Cursos</h2>
              <v-btn @click="modalCurso = true" class="botao-principal">
                <v-icon small class="mr-2">fas fa-circle-plus</v-icon>Adicionar
              </v-btn>
            </v-row>
            <v-container>
              <v-card v-if="dados_pessoais.isPJ" class="textPJ">
                {{ textoResponsabilidadePJ }}
              </v-card>
              <v-data-table
                :headers="cabecalhoCursos"
                :items="cursos"
                :no-data-text="'Você não possui cursos cadastrados!'"
              >
                <template v-slot:item.descricao="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div class="truncate" v-on="on">{{ item.descricao }}</div>
                    </template>
                    <span>{{ item.descricao }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <div :class="statusValidacao(item.status)" v-on="on">
                        {{ item.status }}
                      </div>
                    </template>
                    <span>{{
                      item.justificativa || 'Justificativa não disponível para este status.'
                    }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:item.acoes="{ item }">
                  <div class="acoes-tabela">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          aria-label="Baixar curso"
                          @click="downloadCurso(item)"
                        >
                          <v-icon class="icone-acao">fa fa-download</v-icon>
                        </v-btn>
                      </template>
                      Baixar
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          aria-label="Editar curso"
                          @click="modalCursos(item)"
                        >
                          <v-icon class="icone-acao">fas fa-pen editar</v-icon>
                        </v-btn>
                      </template>
                      Editar
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          aria-label="Excluir curso"
                          @click="modalExclusao(item.codCurso, 'curso')"
                        >
                          <v-icon class="icone-acao">fas fa-trash excluir</v-icon>
                        </v-btn>
                      </template>
                      Excluir
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <!-- Escolaridade -->
          <v-tab-item value="tab-3">
            <v-row class="titulo-tab">
              <h2 class="titulo-secao">Escolaridade</h2>
              <v-btn @click="modalEscolaridade = true" class="botao-principal">
                <v-icon small class="mr-2">fas fa-circle-plus</v-icon>Adicionar
              </v-btn>
            </v-row>
            <v-container>
              <v-card v-if="dados_pessoais.isPJ" class="textPJ">
                {{ textoResponsabilidadePJ }}
              </v-card>
              <v-data-table
                hide-default-footer
                :headers="cabecalhoEscolaridade"
                :items="escolaridade"
                :no-data-text="'Você não possui formações cadastradas!'"
              >
                <template v-slot:item.documentoValido="{ item }">
                  <div :class="statusValidacao(item.documentoValido)">
                    <span
                    v-if="item.documentoValido === null">
                   Aguardando validação
                  </span>
                  <span
                    v-if="item.documentoValido">
                    Validado
                  </span>
                   <span
                    v-if="item.documentoValido === false">
                  Invalidado
                  </span>
                  </div>
                </template>
                <template v-slot:item.acoes="{ item }">
                  <div class="acoes-tabela">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="btn-acao-tabela"
                          aria-label="Baixar"
                          @click="downloadEscolaridade(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="icone-acao">fa fa-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Baixar</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="btn-acao-tabela"
                          aria-label="Editar"
                          @click="modalEscolaridades(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="icone-acao">fas fa-pen editar</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          class="btn-acao-tabela"
                          aria-label="Excluir"
                          @click="modalExclusao(item.id, 'escolaridade')"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="icone-acao">fas fa-trash excluir</v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
          <!-- Experiência Técnica -->
          <v-tab-item value="tab-4">
            <v-row class="titulo-tab">
              <h2 class="titulo-secao">Experiência Técnica</h2>
            </v-row>
            <!-- Básica -->
            <v-row class="row-experiencia">
              <v-col cols="12" sm="9" class="list-experiencia">Básica</v-col>
              <v-col cols="12" sm="3" class="py-0">
                <v-btn
                  @click="(modalExperiencia = true), (nivelExperiencia = 1)"
                  class="botao-principal botao-experiencia w-100"
                >
                  <v-icon small class="mr-2">fas fa-circle-plus</v-icon>Adicionar
                </v-btn>
              </v-col>
            </v-row>
            <div>
              <v-card v-if="experienciaBasica.length < 1" class="card-experiencia">
                <div class="text-experiencia">Você não possui experiência cadastradas!</div>
              </v-card>
              <v-card v-else class="card-experiencia">
                <div v-for="experienciaTecnica in experienciaBasica" class="experiencias">
                  <p>{{ experienciaTecnica.descricao }}</p>
                  <v-btn
                    icon
                    x-small
                    class="btn-acao-tabela"
                    :aria-label="`Remover experiência ${experienciaTecnica.descricao}`"
                    @click="deletarExperiencia(experienciaTecnica)"
                  >
                    <v-icon class="iconListExperiencia">fas fa-times</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
            <!-- Intermediária -->
            <v-row class="row-experiencia">
              <v-col cols="12" sm="9" class="list-experiencia">Intermediária</v-col>
              <v-col cols="12" sm="3" class="py-0">
                <v-btn
                  @click="(modalExperiencia = true), (nivelExperiencia = 2)"
                  class="botao-principal botao-experiencia w-100"
                >
                  <v-icon small class="mr-2">fas fa-circle-plus</v-icon>Adicionar
                </v-btn>
              </v-col>
            </v-row>
            <div>
              <v-card v-if="experienciaIntermediaria.length < 1" class="card-experiencia">
                <div class="text-experiencia">Você não possui experiência cadastradas!</div>
              </v-card>
              <v-card v-else class="card-experiencia">
                <div v-for="experienciaTecnica in experienciaIntermediaria" class="experiencias">
                  <p>{{ experienciaTecnica.descricao }}</p>
                  <v-btn
                    icon
                    x-small
                    class="btn-acao-tabela"
                    :aria-label="`Remover experiência ${experienciaTecnica.descricao}`"
                    @click="deletarExperiencia(experienciaTecnica)"
                  >
                    <v-icon class="iconListExperiencia">fas fa-times</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
            <!-- Avançada -->
            <v-row class="row-experiencia">
              <v-col cols="12" sm="9" class="list-experiencia">Avançada</v-col>
              <v-col cols="12" sm="3" class="py-0">
                <v-btn
                  @click="(modalExperiencia = true), (nivelExperiencia = 3)"
                  class="botao-principal botao-experiencia w-100"
                >
                  <v-icon small class="mr-2">fas fa-circle-plus</v-icon>Adicionar
                </v-btn>
              </v-col>
            </v-row>
            <div>
              <v-card v-if="experienciaAvancada.length < 1" class="card-experiencia">
                <div class="text-experiencia">Você não possui experiência cadastradas!</div>
              </v-card>
              <v-card v-else class="card-experiencia">
                <div v-for="experienciaTecnica in experienciaAvancada" class="experiencias">
                  <p>{{ experienciaTecnica.descricao }}</p>
                  <v-btn
                    icon
                    x-small
                    class="btn-acao-tabela"
                    :aria-label="`Remover experiência ${experienciaTecnica.descricao}`"
                    @click="deletarExperiencia(experienciaTecnica)"
                  >
                    <v-icon class="iconListExperiencia">fas fa-times</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-container>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import Alerta from '@/components/Alerta.vue';
import ModalCertificacoes from '@/components/EspacoDoColaborador/Formacao/ModalCertificacoes.vue';
import ModalExperiencia from '@/components/EspacoDoColaborador/Formacao/ModalExperiencia.vue';
import ModalEscolaridade from '@/components/EspacoDoColaborador/Formacao/ModalEscolaridade.vue';
import ModalCurso from '@/components/EspacoDoColaborador/Formacao/ModalCurso.vue';
import api from '@/services/Api.js';
import modalMixin from '@/mixins/modalMixin';

export default {
  components: {
    Loader,
    Alerta,
    ModalCertificacoes,
    ModalExperiencia,
    ModalEscolaridade,
    ModalCurso,
  },
  mixins: [modalMixin],
  name: 'formacao',
  data() {
    return {
      tab: null,
      faq: '',
      cursoEditar: {
        codCurso: null,
        nameCurso: '',
        cargaHoraria: null,
        data: '',
        descricao: '',
        nameDocumento: '',
        documento: null,
        justificativa: '',
      },
      escolaridadeEditar: {
        id: null,
        escolaridade: null,
        curso: '',
        idInstituicao: null,
        nomeInstituicao: '',
        cargaHoraria: '',
        conclusao: '',
        previsaoConclusao: null,
        nomeDocumento: null,
      },
      certificacaoEditar: '',
      conteudoFaq: [
        {
          titulo:
            'Para quem é esse sistema? Quem deve cadastrar formações? Eu também devo usar o módulo de formação?',
          conteudo:
            'O sistema é para todo o #TimeHepta e deve receber todo tipo de formação. Todos os colaboradores devem cadastrar seus exames e certificações, diplomas e certificados de cursos diversos e diploma de formação escolar (ensino fundamental, médio, superior e/ou pós-graduação). Entenda a diferença entre os três tipos de formação e quais documentos nos interessam.',
        },
        {
          titulo: 'O que deve ser cadastrado?',
          conteudo:
            'Toda e qualquer documento comprovatório de certificação e exames profissionais, cursos dos mais variados temas e cargas horárias, além da escolaridade formal devem ser cadastrados. Esse sistema tem como objetivo fazer a gestão completa da formação de todos os colaboradores, logo é aberto para a inclusão de todo tipo de conteúdo educacional e profissional.',
        },
        {
          titulo: 'Qual a diferença entre certificação, exame, curso e escolaridade?',
          conteudo:
            'O módulo de Formação foi organizado em três grandes grupos: 1. Certificações e exames: devem ser incluídos aqui todas as provas e exames técnicos, obrigatórios ou opcionais na definição do seu cargo. Aqui estão enquadradas todas as certificações corporativas, isto é, certificados de cursos previstos nos trilhos de desenvolvimento e trilhas de aprendizagem da Academia Hepta, emitidos ou não pela Hepta. Exames são as provas que você precisa passar para obter uma certificação. Algumas certificações exigem apenas que você passe em um único exame, enquanto outras exigem mais de um. Certificações demonstram proficiência técnica. Aqui estão enquadradas todas as certificações técnicas e corporativas, isto é, certificados de cursos estabelecidos nos trilhos de desenvolvimento e trilhas de aprendizagem da Academia Hepta, emitidos ou não pela Hepta. 2. Cursos: espaço para inclusão de cursos livres, cursos técnicos e profissionalizantes e cursos de extensão nos mais diferentes temas e formatos. Devem ser incluídos aqui os cursos e treinamentos de qualquer área, desde que não se enquadrem nos outros dois grupos (certificações/exames ou escolaridade). Por exemplo, se você fez um curso preparatório para a certificação Microsoft 365 e recebeu um certificado da instituição formadora, ele deverá ser cadastrado nesse espaço. Assim, mesmo que você não tenha finalizado os exames e a certificação em si, obteve um certificado do curso e já deve incluir em seu cadastro de formação. 3. Escolaridade: como o nome diz, esse é o espaço para incluir diplomas de sua escolaridade, sendo importante incluir os dados do nível mais alto de formação. Assim, se você concluiu o ensino médio ou superior e fez um curso técnico, profissionalizante ou de extensão, deve inserir aqui apenas o diploma do ensino médio ou superior, pois apenas eles indicam o grau de escolaridade. Por outro lado, se você tem pós-graduação é importante incluir também o(s) diploma(s) de graduação.',
        },
        {
          titulo: 'Quais exames e certificações devem ser cadastradas?',
          conteudo:
            ' Somos uma empresa de TI, logo teremos muitas certificações e exames nesta área. Para muitos cargos, elas são inclusive obrigatórias. Mas também devem ser cadastrados certificações e exames de outras áreas, por exemplo proficiência em idiomas e formação profissional. Todas os exames/provas e certificações técnicas e profissionais dos mais diversos fornecedores (AWS, Microsoft, Citrix, HDI, ITIL, PMI, etc) devem ser inseridos no sistema, inclusive os descontinuados. Entenda por que você deve cadastrar exame/prova e certificação e porque precisamos também dos exames/provas e certificações descontinuados. Se a sua certificação não estiver na lista, clique aqui para que a equipe da Academia Hepta possa avaliar e definir pela inclusão ou não. Você será informado quando estiver disponível.',
        },
        {
          titulo: 'Por que preciso cadastrar exames/provas e a certificação?',
          conteudo:
            'Lembre-se que algumas provas são utilizadas para mais de uma certificação, por isso, é muito importante que o colaborador cadastre todas as provas que fez, além da certificação obtida. Assim, será possível para a GPC identificar, por exemplo, colaboradores que já tem parte das provas para uma outra certificação. Se o exame ou certificação que você fez não estiver na lista, clique aqui para que a equipe da Academia Hepta possa avaliar e definir pela inclusão ou não. Você será informado quando estiver disponível.',
        },
        {
          titulo: 'Por que cadastrar certificações e exames descontinuados?',
          conteudo:
            'Mesmo descontinuados ou fora de validade, esses exames e certificações indicam conhecimento e habilidade técnica. Também é importante destacar que nos contratos e licitações podem esses exames e certificações podem ser solicitados, ou podem surgir como opções de substituição. Se o exame ou certificação que você fez não estiver na lista, clique aqui para que a equipe da Academia Hepta possa avaliar e definir pela inclusão ou não. Você será informado quando estiver disponível.',
        },
        {
          titulo:
            'Diplomas e certificados de outras áreas também devem ser cadastrados? Devo inserir certificações e cursos de qualquer área ou tema?',
          conteudo:
            'Sim! Todo tipo de diploma e certificado de formação profissional deve ser inserido. Nosso time não é formado apenas na área de tecnologia e um bom profissional é a soma de diversos conhecimentos e habilidades que formam um grande caldeirão de competências.',
        },
        {
          titulo: 'Não encontrou na lista do módulo o que procurava?',
          conteudo:
            'O formulário de cadastro de certificações e exames apresenta uma longa lista de opções, mas se você não encontrar o nome do seu exame ou certificado, basta clicar aqui (ou na opção de indicar certificação que aparece no formulário) e enviar os dados para avaliação da equipe da Academia Hepta. Eles irão avaliar sua sugestão, verificar se já consta na lista com nome similar e, se for o caso, inserir a nova opção na lista. Qualquer que seja o resultado, você receberá um email de resposta. Nos formulários de Cursos e Escolaridade, o nome do curso é livre. Já a lista de instituições de ensino é de responsabilidade do Ministério da Educação. Se você não encontrou a instituição onde se formou, envie todas as informações para que a GPC possa avaliar se há similaridade (por exemplo, se a instituição mudou de nome – UniCeub se chamava Ceub há alguns anos) e, se for o caso, possa incluir o nome na lista.',
        },
        {
          titulo: 'O que faço se não tenho certificações ou exames para cadastrar?',
          conteudo:
            'Para que possamos ter certeza que seu cadastro está atualizado, mesmo sem nenhum exame ou certificação cadastrada, clique no link “Confirmar que meu cadastro está atualizado”. Não deixe de incluir cursos e sua escolaridade. Todas essas informações são muito importantes para traçarmos as melhores práticas e trilhas de aprendizagem para o crescimento profissional do nosso #capitalhumano.',
        },
        {
          titulo: 'Quando fazer o cadastro?',
          conteudo:
            'Sempre que você for aprovado em um exame, tirar uma certificação, concluir um curso ou grau de escolaridade deve realizar o cadastro. Assim você mantém seus dados sempre at ',
        },
        {
          titulo: 'Como usar o formulário CERTIFICAÇÃO/EXAME?',
          conteudo:
            'Em certificação/Exame, ao começar a digitar pelo termo da certificação, exame irá aparecer uma lista para que você encontre mais rápido o que procura. Se preferir, antes de digitar no campo, confira a lista completa que está organizada por ordem alfabética. Se você não encontrar sua prova ou certificação na lista, basta clicar no link disponível na parte inferior do cadastro e preencher o formulário com os dados solicitados. Em documento, selecione certificado para comprovar a realização da certificação ou exame informado. O sistema aceita arquivo em PDF com limite de tamanho de até 1GB. Documentos faq Por fim, informe a data de emissão e data de validade (se houver) e envie. Se mudar de ideia e quiser cadastrar em outro momento é só cancelar ou sair da página. Emissao faq Sem nenhum certificado, certificação ou exame para cadastrar, isso significa que o seu cadastro está atualizado, portanto, clique no botão “cadastro atualizado” // clique no link “Confirmar que meu cadastro está atualizado”. Essa informação também é muito importante para traçarmos as melhores práticas e trilhas de aprendizagem para o crescimento profissional do nosso #capitalhumano. Em caso de dúvidas e sugestões, envie e-mail para academia@hepta.com.br',
        },
        {
          titulo: 'Como usar o formulário de CURSOS?',
          conteudo:
            'Lembre-se que esse espaço deve ser usado para inserção de todos os cursos, mas se você realmente não tem nenhum curso para cadastrar, isso significa que o seu cadastro está atualizado, portanto, clique no link “Confirmar que meu cadastro está atualizado”. Essa informação também é muito importante para traçarmos as melhores práticas e trilhas de aprendizagem para o crescimento profissional do nosso #capitalhumano. Confirmar cadastro faq Para cadastrar os seus cursos, clique em Adicionar Curso e preencha o formulário abaixo. Os campos Nome do curso e Instituição são livres, ou seja, não há uma lista prévia com opções para serem selecionadas. Instituicoes faq Preencha a carga horária e ano de conclusão. Em Certificado, selecione o documento para comprovar a realização do curso informado. O sistema aceita arquivo em PDF com limite de tamanho de até 1GB. Carga horária faq Logo abaixo, existe um campo para que possa fazer uma descrição e inserir informações sobre o curso cadastrado. Por último, clique em salvar . Se mudar de ideia e quiser cadastrar em outro momento é só cancelar ou sair da página. Carga horária faq Em caso de dúvidas e sugestões, envie e-mail para academia@hepta.com.br',
        },
        {
          titulo: 'Como usar o formulário de ESCOLARIDADE?',
          conteudo:
            'Em escolaridade, o campo é uma lista suspensa com todos os graus/níveis de escolaridade do básico ao avançando, selecione o grau em que se enquadra para continuar preenchendo o formulário. Minha formação faq Informe o nome do Curso conforme consta no diploma. Minha formação faq Em Instituição, ao começar a digitar pelo menos 5 letras do nome da instituição irá aparecer uma lista para que você encontre mais rápido o que procura. Minha formação faq Se não encontrar a sua instituição clique no link de email abaixo do campo para solicitar a inclusão e volte para preencher quando estiver cadastrada. Minha formação faq Continuando, informe a carga horária e data de conclusão ou previsão de término. Minha formação faq Por fim, selecione o documento para comprovar a situação da escolaridade, pode ser uma declaração de matrícula ou certificado, depois é só salvar. O sistema aceita arquivo em PDF com limite de tamanho de até 1GB. Comprovante de escolaridade faq',
        },
      ],
      conteudoFaqFiltrado: [
        {
          titulo:
            'Para quem é esse sistema? Quem deve cadastrar formações? Eu também devo usar o módulo de formação?',
          conteudo:
            'O sistema é para todo o #TimeHepta e deve receber todo tipo de formação. Todos os colaboradores devem cadastrar seus exames e certificações, diplomas e certificados de cursos diversos e diploma de formação escolar (ensino fundamental, médio, superior e/ou pós-graduação). Entenda a diferença entre os três tipos de formação e quais documentos nos interessam.',
        },
        {
          titulo: 'O que deve ser cadastrado?',
          conteudo:
            'Toda e qualquer documento comprovatório de certificação e exames profissionais, cursos dos mais variados temas e cargas horárias, além da escolaridade formal devem ser cadastrados. Esse sistema tem como objetivo fazer a gestão completa da formação de todos os colaboradores, logo é aberto para a inclusão de todo tipo de conteúdo educacional e profissional.',
        },
        {
          titulo: 'Qual a diferença entre certificação, exame, curso e escolaridade?',
          conteudo:
            'O módulo de Formação foi organizado em três grandes grupos: 1. Certificações e exames: devem ser incluídos aqui todas as provas e exames técnicos, obrigatórios ou opcionais na definição do seu cargo. Aqui estão enquadradas todas as certificações corporativas, isto é, certificados de cursos previstos nos trilhos de desenvolvimento e trilhas de aprendizagem da Academia Hepta, emitidos ou não pela Hepta. Exames são as provas que você precisa passar para obter uma certificação. Algumas certificações exigem apenas que você passe em um único exame, enquanto outras exigem mais de um. Certificações demonstram proficiência técnica. Aqui estão enquadradas todas as certificações técnicas e corporativas, isto é, certificados de cursos estabelecidos nos trilhos de desenvolvimento e trilhas de aprendizagem da Academia Hepta, emitidos ou não pela Hepta. 2. Cursos: espaço para inclusão de cursos livres, cursos técnicos e profissionalizantes e cursos de extensão nos mais diferentes temas e formatos. Devem ser incluídos aqui os cursos e treinamentos de qualquer área, desde que não se enquadrem nos outros dois grupos (certificações/exames ou escolaridade). Por exemplo, se você fez um curso preparatório para a certificação Microsoft 365 e recebeu um certificado da instituição formadora, ele deverá ser cadastrado nesse espaço. Assim, mesmo que você não tenha finalizado os exames e a certificação em si, obteve um certificado do curso e já deve incluir em seu cadastro de formação. 3. Escolaridade: como o nome diz, esse é o espaço para incluir diplomas de sua escolaridade, sendo importante incluir os dados do nível mais alto de formação. Assim, se você concluiu o ensino médio ou superior e fez um curso técnico, profissionalizante ou de extensão, deve inserir aqui apenas o diploma do ensino médio ou superior, pois apenas eles indicam o grau de escolaridade. Por outro lado, se você tem pós-graduação é importante incluir também o(s) diploma(s) de graduação.',
        },
        {
          titulo: 'Quais exames e certificações devem ser cadastradas?',
          conteudo:
            ' Somos uma empresa de TI, logo teremos muitas certificações e exames nesta área. Para muitos cargos, elas são inclusive obrigatórias. Mas também devem ser cadastrados certificações e exames de outras áreas, por exemplo proficiência em idiomas e formação profissional. Todas os exames/provas e certificações técnicas e profissionais dos mais diversos fornecedores (AWS, Microsoft, Citrix, HDI, ITIL, PMI, etc) devem ser inseridos no sistema, inclusive os descontinuados. Entenda por que você deve cadastrar exame/prova e certificação e porque precisamos também dos exames/provas e certificações descontinuados. Se a sua certificação não estiver na lista, clique aqui para que a equipe da Academia Hepta possa avaliar e definir pela inclusão ou não. Você será informado quando estiver disponível.',
        },
        {
          titulo: 'Por que preciso cadastrar exames/provas e a certificação?',
          conteudo:
            'Lembre-se que algumas provas são utilizadas para mais de uma certificação, por isso, é muito importante que o colaborador cadastre todas as provas que fez, além da certificação obtida. Assim, será possível para a GPC identificar, por exemplo, colaboradores que já tem parte das provas para uma outra certificação. Se o exame ou certificação que você fez não estiver na lista, clique aqui para que a equipe da Academia Hepta possa avaliar e definir pela inclusão ou não. Você será informado quando estiver disponível.',
        },
        {
          titulo: 'Por que cadastrar certificações e exames descontinuados?',
          conteudo:
            'Mesmo descontinuados ou fora de validade, esses exames e certificações indicam conhecimento e habilidade técnica. Também é importante destacar que nos contratos e licitações podem esses exames e certificações podem ser solicitados, ou podem surgir como opções de substituição. Se o exame ou certificação que você fez não estiver na lista, clique aqui para que a equipe da Academia Hepta possa avaliar e definir pela inclusão ou não. Você será informado quando estiver disponível.',
        },
        {
          titulo:
            'Diplomas e certificados de outras áreas também devem ser cadastrados? Devo inserir certificações e cursos de qualquer área ou tema?',
          conteudo:
            'Sim! Todo tipo de diploma e certificado de formação profissional deve ser inserido. Nosso time não é formado apenas na área de tecnologia e um bom profissional é a soma de diversos conhecimentos e habilidades que formam um grande caldeirão de competências.',
        },
        {
          titulo: 'Não encontrou na lista do módulo o que procurava?',
          conteudo:
            'O formulário de cadastro de certificações e exames apresenta uma longa lista de opções, mas se você não encontrar o nome do seu exame ou certificado, basta clicar aqui (ou na opção de indicar certificação que aparece no formulário) e enviar os dados para avaliação da equipe da Academia Hepta. Eles irão avaliar sua sugestão, verificar se já consta na lista com nome similar e, se for o caso, inserir a nova opção na lista. Qualquer que seja o resultado, você receberá um email de resposta. Nos formulários de Cursos e Escolaridade, o nome do curso é livre. Já a lista de instituições de ensino é de responsabilidade do Ministério da Educação. Se você não encontrou a instituição onde se formou, envie todas as informações para que a GPC possa avaliar se há similaridade (por exemplo, se a instituição mudou de nome – UniCeub se chamava Ceub há alguns anos) e, se for o caso, possa incluir o nome na lista.',
        },
        {
          titulo: 'O que faço se não tenho certificações ou exames para cadastrar?',
          conteudo:
            'Para que possamos ter certeza que seu cadastro está atualizado, mesmo sem nenhum exame ou certificação cadastrada, clique no link “Confirmar que meu cadastro está atualizado”. Não deixe de incluir cursos e sua escolaridade. Todas essas informações são muito importantes para traçarmos as melhores práticas e trilhas de aprendizagem para o crescimento profissional do nosso #capitalhumano.',
        },
        {
          titulo: 'Quando fazer o cadastro?',
          conteudo:
            'Sempre que você for aprovado em um exame, tirar uma certificação, concluir um curso ou grau de escolaridade deve realizar o cadastro. Assim você mantém seus dados sempre at ',
        },
        {
          titulo: 'Como usar o formulário CERTIFICAÇÃO/EXAME?',
          conteudo:
            'Em certificação/Exame, ao começar a digitar pelo termo da certificação, exame irá aparecer uma lista para que você encontre mais rápido o que procura. Se preferir, antes de digitar no campo, confira a lista completa que está organizada por ordem alfabética. Se você não encontrar sua prova ou certificação na lista, basta clicar no link disponível na parte inferior do cadastro e preencher o formulário com os dados solicitados. Em documento, selecione certificado para comprovar a realização da certificação ou exame informado. O sistema aceita arquivo em PDF com limite de tamanho de até 1GB. Documentos faq Por fim, informe a data de emissão e data de validade (se houver) e envie. Se mudar de ideia e quiser cadastrar em outro momento é só cancelar ou sair da página. Emissao faq Sem nenhum certificado, certificação ou exame para cadastrar, isso significa que o seu cadastro está atualizado, portanto, clique no botão “cadastro atualizado” // clique no link “Confirmar que meu cadastro está atualizado”. Essa informação também é muito importante para traçarmos as melhores práticas e trilhas de aprendizagem para o crescimento profissional do nosso #capitalhumano. Em caso de dúvidas e sugestões, envie e-mail para academia@hepta.com.br',
        },
        {
          titulo: 'Como usar o formulário de CURSOS?',
          conteudo:
            'Lembre-se que esse espaço deve ser usado para inserção de todos os cursos, mas se você realmente não tem nenhum curso para cadastrar, isso significa que o seu cadastro está atualizado, portanto, clique no link “Confirmar que meu cadastro está atualizado”. Essa informação também é muito importante para traçarmos as melhores práticas e trilhas de aprendizagem para o crescimento profissional do nosso #capitalhumano. Confirmar cadastro faq Para cadastrar os seus cursos, clique em Adicionar Curso e preencha o formulário abaixo. Os campos Nome do curso e Instituição são livres, ou seja, não há uma lista prévia com opções para serem selecionadas. Instituicoes faq Preencha a carga horária e ano de conclusão. Em Certificado, selecione o documento para comprovar a realização do curso informado. O sistema aceita arquivo em PDF com limite de tamanho de até 1GB. Carga horária faq Logo abaixo, existe um campo para que possa fazer uma descrição e inserir informações sobre o curso cadastrado. Por último, clique em salvar . Se mudar de ideia e quiser cadastrar em outro momento é só cancelar ou sair da página. Carga horária faq Em caso de dúvidas e sugestões, envie e-mail para academia@hepta.com.br',
        },
        {
          titulo: 'Como usar o formulário de ESCOLARIDADE?',
          conteudo:
            'Em escolaridade, o campo é uma lista suspensa com todos os graus/níveis de escolaridade do básico ao avançando, selecione o grau em que se enquadra para continuar preenchendo o formulário. Minha formação faq Informe o nome do Curso conforme consta no diploma. Minha formação faq Em Instituição, ao começar a digitar pelo menos 5 letras do nome da instituição irá aparecer uma lista para que você encontre mais rápido o que procura. Minha formação faq Se não encontrar a sua instituição clique no link de email abaixo do campo para solicitar a inclusão e volte para preencher quando estiver cadastrada. Minha formação faq Continuando, informe a carga horária e data de conclusão ou previsão de término. Minha formação faq Por fim, selecione o documento para comprovar a situação da escolaridade, pode ser uma declaração de matrícula ou certificado, depois é só salvar. O sistema aceita arquivo em PDF com limite de tamanho de até 1GB. Comprovante de escolaridade faq',
        },
      ],
      cabecalhoCertificacoes: [
        {
          text: 'Nome',
          value: 'nomeCertificacao',
        },
        {
          text: 'Emissão',
          value: 'dataEmissao',
          align: 'center',
        },
        {
          text: 'Validade',
          value: 'dataValidade',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'indAuditado',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'indDocumentoValido',
          align: 'center',
          sortable: false,
        },
      ],
      cabecalhoCursos: [
        {
          text: 'Nome',
          value: 'nameCurso',
        },
        {
          text: 'Instituição',
          value: 'instituicao',
          align: 'center',
        },
        {
          text: 'Descrição',
          value: 'descricao',
          sortable: false,
          width: '15rem',
        },
        {
          text: 'Carga Horária',
          value: 'cargaHoraria',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Conclusão',
          value: 'dataFormatada',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'acoes',
          align: 'center',
          sortable: false,
        },
      ],
      cabecalhoEscolaridade: [
        {
          text: 'Nome',
          value: 'curso',
        },
        {
          text: 'Escolaridade',
          value: 'nomeEscolaridade',
        },
        {
          text: 'Instituição',
          value: 'nomeInstituicao',
          align: 'center',
        },
        {
          text: 'Carga Horária',
          value: 'cargaHoraria',
          align: 'center',
        },
        {
          text: 'Conclusão',
          value: 'conclusaoFormatada',
          align: 'center',
        },
        {
          text: 'Status',
          value: 'documentoValido',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Ações',
          value: 'acoes',
          align: 'center',
          sortable: false,
        },
      ],
      nivelExperiencia: 0,
      modalCertificacoes: false,
      modalExperiencia: false,
      modalEscolaridade: false,
      modalCurso: false,
      loader: false,
      certificacoes: [],
      cursos: [],
      experiencia: [],
      experienciaBasica: [],
      experienciaIntermediaria: [],
      experienciaAvancada: [],
      escolaridade: [],
      tipoExclusao: '',
      usuarioCLT: null,
      dados_pessoais: {
        nome: '',
        cargo: '',
        lotacao: '',
        telefone: '',
        email: '',
        imagemBase64: '',
        nomeFornecedor: '',
        isPJ: false,
        idFornecedor: '',
        nomeResponsavel: '',
        tipoFornecedor: '',
      },
      numeroPendentes: 0,
    };
  },
  computed: {
    textoResponsabilidadePJ() {
      const base =
        'Como prestador de serviço, os dados de sua formação aqui inseridos estão previstos em contrato';
      const fornecedor = this.dados_pessoais.nomeFornecedor;
      const responsavel = this.dados_pessoais.nomeResponsavel;
      if (!fornecedor) return `${base}.`;
      return `${base} e são de responsabilidade de ${fornecedor}${
        responsavel ? ' – ' + responsavel : ''
      }.`;
    },
  },
  methods: {
    statusValidacao(status) {
      if (status === null) return 'status-tabela status-pendente';
      
      else if (status === true) return 'status-tabela status-validado';
        
      else if (status === false) return 'status-tabela status-invalidado';
    
    },
    fechaModalCurso() {
      this.modalCurso = false;
      this.cursoEditar = {
        codCurso: null,
        nameCurso: '',
        cargaHoraria: null,
        data: null,
        descricao: '',
        nameDocumento: '',
        documento: null,
        justificativa: '',
      };
      this.buscarCursosColaborador();
    },
    fechaModalFormacao() {
      this.modalEscolaridade = false;
      this.escolaridadeEditar = {
        id: null,
        escolaridade: null,
        curso: '',
        idInstituicao: null,
        nomeInstituicao: '',
        cargaHoraria: '',
        conclusao: '',
        previsaoConclusao: null,
        nomeDocumento: null,
      };
      this.listarEscolaridade();
    },
    filtrarFaq() {
      this.conteudoFaqFiltrado = [];
      this.conteudoFaq.map(cf => {
        if (cf.titulo.toUpperCase().includes(this.faq.toUpperCase())) {
          this.conteudoFaqFiltrado.push(cf);
        }
      });
    },
    buscarCertificacoesColaborador() {
      const vm = this;
      vm.loader = true;
      api
        .get('/certificacao/colaborador')
        .then(res => {
          this.certificacoes = res.data;
        })
        .catch(err => {
          vm.mensagemErro(err);
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    buscarCursosColaborador() {
      const vm = this;
      vm.loader = true;
      vm.cursos = [];
      api
        .get('cursos')
        .then(res => {
          let listaTemp = res.data;
          for (let i in listaTemp) {
            listaTemp[i].showJustificativa = false;
            vm.cursos.push(listaTemp[i]);
          }
        })
        .catch(err => {
          vm.mensagemErro(err);
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    listarEscolaridade() {
      const vm = this;
      vm.loader = true;
      api
        .get('colaborador-formacao')
        .then(res => {
          vm.escolaridade = res.data;
        })
        .catch(err => {
          vm.mensagemErro(err);
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    modalExclusao(codExclusao, tipoExclusao) {
      const vm = this;
      vm.confirmarExclusao('Deseja confirmar a exclusão?', codExclusao);
      vm.tipoExclusao = tipoExclusao;
    },
    excluir() {
      const vm = this;
      if (vm.tipoExclusao == 'certificacao') {
        vm.excluirCertificacao();
      } else if (vm.tipoExclusao == 'curso') {
        vm.excluirCurso();
      } else if (vm.tipoExclusao == 'escolaridade') {
        vm.excluirEscolaridade();
      }
    },
    excluirCertificacao() {
      const vm = this;
      //exclusaoConfirmada é o id de exclusao salvo no mixin
      let codPessoaCertificacao = vm.exclusaoConfirmada;
      vm.fecharModal();
      vm.loader = true;
      api
        .delete(`certificacao/colaborador/desfazer?codPessoaCertificacao=` + codPessoaCertificacao)
        .then(() => {
          vm.mensagemSucesso('Excluído com sucesso!');
        })
        .catch(e => {
          vm.mensagemErro(e.message);
        })
        .finally(() => {
          vm.loader = false;
          vm.tipoExclusao = '';
          vm.buscarCertificacoesColaborador();
        });
    },
    excluirCurso() {
      const vm = this;
      //exclusaoConfirmada é o id de exclusao salvo no mixin
      let idCurso = vm.exclusaoConfirmada;
      vm.fecharModal();
      vm.loader = true;
      api
        .delete(`cursos/${idCurso}`)
        .then(() => {
          vm.mensagemSucesso('Curso excluído com sucesso!');
        })
        .catch(e => {
          vm.mensagemErro(e.message);
        })
        .finally(() => {
          vm.loader = false;
          vm.tipoExclusao = '';
          vm.buscarCursosColaborador();
        });
    },
    excluirEscolaridade() {
      const vm = this;
      //exclusaoConfirmada é o id de exclusao salvo no mixin
      let idFormcacao = vm.exclusaoConfirmada;
      vm.fecharModal();
      vm.loader = true;
      api
        .delete(`colaborador-formacao/${idFormcacao}`)
        .then(() => {
          vm.mensagemSucesso('Excluído com sucesso!');
        })
        .catch(e => {
          vm.mensagemErro(e.message);
        })
        .finally(() => {
          vm.loader = false;
          vm.tipoExclusao = '';
          vm.listarEscolaridade();
        });
    },
    thisLoader(boolean) {
      this.loader = boolean;
    },
    limpaVariaveisExperiencia() {
      const vm = this;
      vm.experienciaBasica = [];
      vm.experienciaIntermediaria = [];
      vm.experienciaAvancada = [];
    },
    modalCursos(curso) {
      this.cursoEditar = curso;
      this.modalCurso = true;
    },
    modalEscolaridades(escolaridade) {
      this.escolaridadeEditar = escolaridade;
      this.modalEscolaridade = true;
    },
    buscarExperienciaPessoa() {
      const vm = this;
      vm.loader = true;
      vm.limpaVariaveisExperiencia();
      api
        .get(`experiencia/pessoa`)
        .then(res => {
          this.experiencia = res.data;
          let basica = [];
          let intermediaria = [];
          let avancada = [];
          res.data.map(e => {
            if (e.idNivel == 1) {
              basica.push(e);
            }
            if (e.idNivel == 2) {
              intermediaria.push(e);
            }
            if (e.idNivel == 3) {
              avancada.push(e);
            }
          });
          this.experienciaBasica = basica;
          this.experienciaIntermediaria = intermediaria;
          this.experienciaAvancada = avancada;
        })
        .catch(err => {
          this.mensagem('Erro!', 'Não foi possivel carragar experiencias cadastradas');
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    dataItem(data) {
      if (data) {
        return data.split('-').reverse().join('/');
      } else {
        return 'Sem validade';
      }
    },
    deletarExperiencia(experiencia) {
      const vm = this;
      vm.loader = true;
      api
        .delete(`experiencia/pessoa/${experiencia.id}`)
        .then(res => {
          if (res.status == 200) {
            this.limpaVariaveisExperiencia();
            this.buscarExperienciaPessoa();
          }
        })
        .catch(err => {
          this.mensagemErro(err);
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    downloadCertificacao(certificacao) {
      const vm = this;
      vm.loader = true;
      api
        .get(`certificacao/colaborador/documento/${certificacao.codCertificacao}`, {
          responseType: 'arraybuffer',
          headers: {},
        })
        .then(function (response) {
          if (!response.data || response.data.byteLength === 0) {
            vm.mensagem('Atenção!', 'Documento não encontrado para esta certificação.');
            return;
          }
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(
            `download`,
            `${certificacao.nomeCertificacao.replace(/[\\/:*?"<>|]/g, '-')}.pdf`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          vm.mensagem('Erro!', 'Não foi possível baixar o documento desta certificação.');
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    downloadCurso(curso) {
      const vm = this;
      vm.loader = true;
      api
        .get(`cursos/download/${curso.codCurso}`, {
          responseType: 'arraybuffer',
          headers: {},
        })
        .then(function (response) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(`download`, `${curso.nameDocumento}.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    downloadEscolaridade(formacao) {
      const vm = this;
      vm.loader = true;
      api
        .get(`colaborador-formacao/download/${formacao.id}`, {
          responseType: 'arraybuffer',
          headers: {},
        })
        .then(function (response) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute(`download`, `formacao.pdf`);
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          vm.loader = false;
        });
    },
    criarCurso(dados) {
      const vm = this;
      vm.loader = true;
      api
        .post('cursos', dados)
        .then(() => {
          vm.mensagemSucesso('Salvo com sucesso!');
        })
        .catch(err => {
          vm.mensagem('Erro!', 'Erro ao salvar curso!');
        })
        .finally(() => {
          vm.loader = false;
          this.buscarCursosColaborador();
        });
    },
    atualizarCurso(idCurso, dados) {
      const vm = this;
      vm.loader = true;
      api
        .put(`cursos/${idCurso}`, dados)
        .then(() => {
          vm.mensagemSucesso('Editado com sucesso!');
        })
        .catch(err => {
          vm.mensagem('Erro!', 'Erro ao editar curso!');
        })
        .finally(() => {
          vm.loader = false;
          this.buscarCursosColaborador();
        });
    },
    criarEscolaridade(dados) {
      const vm = this;
      vm.loader = true;
      api
        .post('colaborador-formacao', dados)
        .then(() => {
          vm.mensagemSucesso('Salvo com sucesso!');
        })
        .catch(err => {
          vm.mensagem('Erro!', 'Erro ao salvar formação!');
        })
        .finally(() => {
          vm.loader = false;
          this.listarEscolaridade();
        });
    },
    atualizarEscolaridade(id, dados) {
      const vm = this;
      vm.loader = true;
      api
        .put(`colaborador-formacao/${id}`, dados)
        .then(() => {
          vm.mensagemSucesso('Editado com sucesso!');
        })
        .catch(() => {
          vm.mensagem('Erro!', 'Erro ao editar formação!');
        })
        .finally(() => {
          vm.loader = false;
          this.listarEscolaridade();
        });
    },
    async getCredenciais() {
      let vm = this;
      vm.loader = true;
      await api
        .get('auth/credenciais')
        .then(response => {
          vm.usuario = response.data;
        })
        .catch(e => {
          this.mensagemErro(e.message);
        })
        .finally(() => {
          vm.buscaDadosAD();
          vm.loader = false;
        });
    },
    buscaDadosAD() {
      let vm = this;
      vm.loader = true;
      api
        .get('meusdados/dadosAD')
        .then(response => {
          vm.dados_pessoais = response.data;
          vm.dados_pessoais.isPJ = vm.usuario.isPJ;
          if (vm.usuario.isPJ) {
            vm.dados_pessoais.idFornecedor = vm.usuario.idFornecedor;
            vm.dados_pessoais.nomeFornecedor = vm.usuario.nomeFornecedor;
            vm.dados_pessoais.nomeResponsavel = vm.usuario.nomeResponsavel;
            vm.dados_pessoais.tipoFornecedor = vm.usuario.tipoFornecedor?.descricao || '';
          }
        })
        .catch(e => {
          this.mensagemErro(e);
        })
        .finally(function () {
          setTimeout(function () {
            vm.laoder = false;
          }, 500);
        });
    },
    listaNumeroTreinamentoPendentes() {
      const vm = this;
      vm.loader = true;
      api
        .get('/headerDropDown')
        .then(res => {
          vm.numeroPendentes = res.data.treinamentosPendentes;
        })
        .finally(() => {
          vm.isLoading = false;
        });
    },
  },
  async mounted() {
    await this.getCredenciais();
    await this.buscarCertificacoesColaborador();
    await this.buscarCursosColaborador();
    await this.listarEscolaridade();
    await this.buscarExperienciaPessoa();
    await this.listaNumeroTreinamentoPendentes();
  },
};
</script>

<style scoped>
/* Tabs */
.card::v-deep .v-tabs-bar {
  height: auto;
}

.tab {
  background-color: #edefee;
  border: 1px solid #edefee;
  border-radius: 12px;
  text-align: center;
  text-transform: none;
  letter-spacing: 0px;
  font: normal normal bold 16px/20px Montserrat;
  color: #787878 !important;
  margin: 0 1rem;
  padding: 1rem;
  width: 8rem;
}

.tab::before {
  border-radius: 12px;
}

.tab:hover {
  background-color: #eff9fa;
  border: 1px solid #278b97;
  color: #278b97 !important;
}

.tab-active {
  background-color: #278b97;
  border: 1px solid #278b97;
  color: #fff !important;
}

/* FAQ */
.espaco-input {
  margin: 2rem auto 0;
  width: 95%;
}

.faq {
  margin: 1rem auto;
  width: 95%;
  border-radius: 16px;
}

.faq .v-expansion-panel {
  box-shadow: 0px -1px 8px 4px #00000010;
  color: #5d5d5d !important;
}

.faq .v-expansion-panel:hover {
  color: #52a3ac !important;
  background-color: #eff9fa;
  border: 1px solid #52a3ac;
}

.faq .v-expansion-panel::before {
  display: none;
}

.faq .v-expansion-panel-header {
  min-height: 6rem;
  border-radius: 16px;
  font-size: 1rem;
  font-weight: 600;
}

.faq .v-expansion-panel--active {
  border-radius: 16px !important;
}

/* Tabelas */
.truncate {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 15rem;
}

.status-validado {
  background-color: #32acb9;
}

.status-invalidado {
  background-color: #db1826;
}

.status-pendente {
  background-color: #f8ba00;
}

/* Experiência Técnica */
.row-experiencia {
  margin: 1.5rem 0 0;
}

.botao-experiencia {
  border-radius: 24px !important;
}

.list-experiencia {
  color: #fff;
  background-color: #278b97;
  height: 2.5rem;
  border-radius: 0px 24px 24px 0px;
  padding-left: 1rem;
  margin: 0 0 0.25rem;
  display: flex;
  align-items: center;
}

.card-experiencia {
  display: flex;
  justify-content: flex-start;
  border: 1px solid #000;
  border-radius: 12px;
  margin: 0.5rem 0;
  min-height: 8rem;
  flex-wrap: wrap;
  box-shadow: none !important;
}

.text-experiencia {
  margin: auto;
  padding: 0.5rem;
  text-align: center;
}

.experiencias {
  border-radius: 28px !important;
  background-color: #278b97;
  border-color: #6c757d;
  padding: 0.375rem 0.75rem;
  margin: 0.5rem 0 0.5rem 0.5rem;
  height: 2.25rem;
}

.experiencias p {
  color: white;
  display: contents;
}

.iconListExperiencia {
  font-size: 1rem;
  color: #fff;
  margin-left: 0.25rem;
}

/* Geral */
.destaque {
  color: #f8ba00;
}

.titulo-tab {
  margin: 0;
  padding: 0.25rem 0 1rem;
  justify-content: space-between;
}

.textPJ {
  background-color: #edefeea6;
  border-radius: 20px;
  margin: 1rem;
  padding: 1rem;
  box-shadow: 0px 2px 8px 1px #00000020 !important;
}
</style>
